import { render, staticRenderFns } from "./attachment-info.vue?vue&type=template&id=22faea40&scoped=true&"
import script from "./attachment-info.vue?vue&type=script&lang=js&"
export * from "./attachment-info.vue?vue&type=script&lang=js&"
import style0 from "./attachment-info.vue?vue&type=style&index=0&id=22faea40&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22faea40",
  null
  
)

export default component.exports